import React, { useEffect, useState } from 'react'
import { getApi, postApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import TableComponent from '../../components/DataTable/TableComponent'
import DateRange from '../../components/DateRange/DateRange'
import Pagination from '../../components/Pagination/Pagination'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller'
import { dateIntoYYYY_MM_DD, dateTimeConverter } from '../../utils/dateTimeConverter'
import AddBankModal from './Components/AddBankModal'
import WithdrawModal from './Components/WithdrawModal'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'

const Rewards = ({ settingData }) => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    const [cardsData, setCardsData] = useState(null);



    async function getList() {
        loadingShow();
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let url = `${urlApi.getRewardsList}?page=${activePage}&limit=${perPage}&`;
        let resp = await postApi((date?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    async function getCardsData() {
        loadingShow();
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        };
        let url = `${urlApi.getRewardCardData}`;
        let resp = await postApi((date?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setCardsData(resp.data);
        } else {
            setCardsData(null);
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.viewRewardAnalyticsCard)) { getCardsData(); }
        return () => { }
    }, [date])


    useEffect(() => {
        if (accessCheck(accessKeys?.viewRewardList)) { getList(); }
    }, [date, activePage]);

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setActivePage(1);
        setDate(newDate)
    }

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        { name: "Date", center: "true", selector: (row) => row?.createdAt, cell: (row) => <p className='px-3'>{dateTimeConverter(row?.createdAt)}</p> },
        {
            name: "Link Clicks", selector: (row) => row?.linkClicks, grow: 3.4, cell: (row) => (
                <div className='py-2 px-4'>
                    {row?.linkClicks}
                </div>
            )
        }, {
            name: "Rewards", center: "true", width: 'max-content', selector: (row) => row?.amountEarned, cell: (row) => (
                <div className="flex gap-2 items-center flex-wrap px-3">
                    Rs. {row?.amountEarned}
                </div>
            )
        }
    ];

    return (
        <div>
            <div className="flex flex-wrap items-center gap-3 mb-4">
                <div>
                    <p className='text-[17px] font-bold'>Rewards</p>
                    <p className="text-xs text-gray-600">You will get <b>₹1</b> for every <b>{settingData?.rewardRate}</b> unique clicks.</p>
                    <p className="text-xs text-gray-600">You can withdraw when you have <b>₹{settingData?.minWithdrawForReward}</b> or more Current balance.</p>
                </div>
                <DateRange cssClass={'ms-auto'} date={date} onApplyClick={(e) => onDateChange(e)} />
                {accessCheck(accessKeys?.addBankAccount) && <AddBankModal />}
                {accessCheck(accessKeys?.rewardWithdrawRequest) && <WithdrawModal callback={() => getCardsData()} currentBalance={cardsData?.currentBalance} settingData={settingData} />}
            </div>
            {accessCheck(accessKeys?.viewRewardAnalyticsCard) && <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
                <RewardCard img={"/images/rewards/earning.png"} title={"Total Earning"} description={"By Rewards & Referrals"} valueIcon={"/images/rewards/rupee.png"} value={cardsData?.totalEarning?.toFixed(2)} />
                <RewardCard img={"/images/rewards/bank.png"} title={"Total Withdrawals "} description={"to bank account"} valueIcon={"/images/rewards/rupee.png"} value={cardsData?.totalWithDrawls?.toFixed(2)} />
                <RewardCard img={"/images/rewards/link.png"} title={"Total Link Clicks"} description={"created links"} valueIcon={"/images/rewards/clicks.png"} value={cardsData?.totalLinkClicks?.toFixed(0)} />
                <RewardCard img={"/images/rewards/earning.png"} title={"Current Balance"} description={"Current Balance in wallet"} valueIcon={"/images/rewards/rupee.png"} value={cardsData?.currentBalance?.toFixed(3)} />
            </div>}
            <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Earnings List</p>
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isHeader={true}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </div>
    )
}

export default Rewards;

export const RewardCard = ({ img, title, description, value, valueIcon }) => {
    return (
        <div className="flex flex-wrap items-center gap-3 bg-white rounded-lg p-3">
            <img className='h-14 w-14' src={process.env.PUBLIC_URL + img} alt='' />
            <div>
                <p className='text-[16px] font-bold mb-0'>{title}</p>
                <p className='text-xs text-[#686C8F] mb-1'>{description}</p>
                <div className="flex gap-2 items-center">
                    <img className='h-6 w-auto' src={process.env.PUBLIC_URL + valueIcon} alt="" />
                    <p className='text-[28px] font-extrabold mb-0'>{value}</p>
                </div>
            </div>
        </div>
    )
}